import { merge, get, set } from 'lodash';
import { combineReducers } from 'redux';
import { ACTIONCOMMON } from '../actionTypes';
/**
 * admin start
 */
import { AdminMainReducers } from './admin/main';
import { AdminBaseinfoReducers } from './admin/baseinfo';
import { AdminPromotionReducers } from './admin/promotion';
import { AdminAlbumReducers } from './admin/album';
import { AdminManageReducers } from './admin/account';
/**
 * admin end
 * copyright start
 */
import { CopyrightHomeReducers } from './copyright/home';
import { CopyrightUcenterReducers } from './copyright/ucenter';
import { CopyrightGalleryReducers } from './copyright/gallery';
import { CopyrightPraiseReducers } from './copyright/praise';
import { CopyrightBaseinfoReducers } from './copyright/baseinfo';
import { CopyrightActivityReducers } from './copyright/activity';
import { CopyrightActivityListReducers } from './copyright/activityList';
import { CopyrightEventsReducers } from './copyright/events';
import { CopyrightAuthReducers } from './copyright/auth';
import { CopyrightNewsReducers } from './copyright/news';
/**
 * copyright end
 */
import { ReportDemoReducers } from './report/demo';
let initState = {
	siteSwitch: 0, //企业主页是否开启, 0是关,1开
	wallSwith: 0, //企业背景墙是否开始
	vphotoSwitch: 0,
	moduleName: '', //模块名
	domainName: '', //企业相册修改需要这个字段
	companySiteUrl: '', //预览地址，二维码地址
	canEditDomain: '', //是否可以编辑域名,
	activityShowType: 1 //1默认 , 2 自定义
};
function AdminReducers(state = initState, action) {
	switch (action.type) {
		case ACTIONCOMMON.SET_COMMON_HOMEPAGE: {
			let { siteSwitch, domainName, companySiteUrl, canEditDomain } = get(action, 'payload', {});
			let param = {};
			let { payload = {} } = action;
			if (payload.hasOwnProperty('siteSwitch')) {
				param['siteSwitch'] = payload['siteSwitch'];
			}
			if (payload.hasOwnProperty('domainName')) {
				param['domainName'] = payload['domainName'];
			}
			if (payload.hasOwnProperty('companySiteUrl')) {
				param['companySiteUrl'] = payload['companySiteUrl'];
			}
			if (payload.hasOwnProperty('canEditDomain')) {
				param['canEditDomain'] = payload['canEditDomain'];
			}
			if (payload.hasOwnProperty('activityShowType')) {
				param['activityShowType'] = payload['activityShowType'];
			}
			if (payload.hasOwnProperty('wallSwith')) {
				param['wallSwith'] = payload['wallSwith'];
			}
			if (payload.hasOwnProperty('vphotoSwitch')) {
				param['vphotoSwitch'] = payload['vphotoSwitch'];
			}
			if (payload.hasOwnProperty('moduleName')) {
				param['moduleName'] = payload['moduleName'];
			}
			return merge({}, state, param);
		}
		default:
			return state;
	}
}
const Reducers = combineReducers({
	AdminReducers,
	AdminMainReducers,
	AdminBaseinfoReducers,
	AdminPromotionReducers,
	AdminAlbumReducers,
	AdminManageReducers
});
const CopyrightReducers = combineReducers({
	AdminReducers,
	CopyrightHomeReducers,
	CopyrightUcenterReducers,
	CopyrightBaseinfoReducers,
	CopyrightActivityReducers,
	CopyrightGalleryReducers,
	CopyrightPraiseReducers,
	CopyrightAuthReducers,
	CopyrightNewsReducers,
	CopyrightActivityListReducers,
	CopyrightEventsReducers
});
const ReportReducers = combineReducers({
	ReportDemoReducers
});
export { Reducers, CopyrightReducers, ReportReducers };
